export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M22 17H4a2 2 0 0 1-1.99-1.796L2 15V7h20v10ZM3.5 15a.5.5 0 0 0 .5.5h16.5v-7h-17V15Zm4-1H5v-4h5.5l-3 4Zm3 0h-2l3-4h2l-3 4Zm3 0h-2l3-4h2l-3 4Z"/>
</svg>
`;
